import { apiClient } from '@/lib/apiClient'
import type { UserSidebarSummary } from '@/types/sidebar'

type ApiEnvelope<T> = {
  code: number
  data: T
  message: string
}

export async function getUserSidebarSummary() {
  const response = await apiClient.get<ApiEnvelope<UserSidebarSummary>>('/user/sidebar-summary')
  return response.data
}
